import React, { useState } from 'react';
import { Button, Checkbox, Input, Modal, message } from 'antd';
import { tid } from '@utils/test';
import useUpdateDashboardMeta from '../useUpdateDashboardMeta';
import { FlexFill, FooterWrapper, Title } from './styled';
import { useSelector, useDispatch } from 'react-redux';
import { publicSavedDashboardsSelector } from '@store/common/selectors';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import { getList } from '@store/dashboards/list/actions';

function SaveDashboardMetaPopup({
  id,
  dashboard,
  isPopupOpen,
  closePopup,
  dataToBeSaved,
  onSaveCallback,
}) {
  const { name, isSaved, isPublic } = dataToBeSaved;
  const [dashboardName, setDashboardName] = useState(name);
  const [publicChecked, setPublicChecked] = useState(isPublic);
  const { updateMetaMutation } = useUpdateDashboardMeta();
  const publicSavedDashboardsEnabled = useSelector(publicSavedDashboardsSelector);
  const dispatch = useDispatch();

  const onNameChange = (event) => {
    setDashboardName(event.target.value);
  };

  const togglePublic = (event) => {
    setPublicChecked(event.target.checked);
  };

  const payload = {
    name: dashboardName,
    isSaved,
    isPublic: publicChecked,
  };

  const callUpdateHandler = async () => {
    try {
      const { data } = await updateMetaMutation.mutateAsync({
        id,
        payload,
      });
      closePopup();
      // update dashboard title in tabs
      dispatch(tempDashboardActions.updatedSavedDashboard(id, dashboardName));
      // refetch the list within saved dashboard tab
      dispatch(getList());
      onSaveCallback();
    } catch (error: any) {
      if (error.response && error.response.data) {
        message.error(error.response.data.message);
      }
    }
  };

  const modalTitle = <Title>Update Dashboard</Title>;

  const footerButtons = [
    <FooterWrapper
      key="sd-list-update-popup-footer-wrapper"
      {...tid('sd-list-update-popup-footer-wrapper')}
    >
      {publicSavedDashboardsEnabled || dashboard?.productName === 'app' ? (
        <Checkbox checked={publicChecked} onChange={togglePublic} disabled={isSaved}>
          Make it Public
        </Checkbox>
      ) : null}
      <FlexFill />
      <Button key="sd-list-update-popup-footer-cancel" onClick={closePopup}>
        Cancel
      </Button>
      <Button
        type="primary"
        key="sd-popup-save"
        disabled={dashboardName ? false : true}
        onClick={callUpdateHandler}
      >
        Update
      </Button>
    </FooterWrapper>,
  ];

  return (
    <Modal
      title={modalTitle}
      width={400}
      open={isPopupOpen}
      okText="Update"
      cancelText="Cancel"
      footer={footerButtons}
      maskClosable={true}
      onCancel={closePopup}
    >
      <Input value={dashboardName} placeholder="Dashboard Name" onChange={onNameChange} />
    </Modal>
  );
}

export default SaveDashboardMetaPopup;
